<script lang="ts" setup>
import type { MenuButtonLayout } from '@brighterly/lib-lumee-ui'

import { useLinkStudentApp } from '@composables/widgets/menu/link-student-app.hook'

import HeaderNavItem from '@Molecules/HeaderNavItem.vue'

defineOptions({
  name: 'LinkStudentApp',
})

defineProps<{
  layout: MenuButtonLayout
}>()

const {
  text,
  formRef,
  formData,
  handleClick,
} = useLinkStudentApp()
</script>

<template>
  <form
    v-if="formData"
    ref="formRef"
    class="link-student-app"
    method="post"
    :action="formData.action"
  >
    <input
      type="hidden"
      name="signature"
      :value="formData.signature"
    >
    <input
      type="hidden"
      name="kid"
      :value="formData.kid"
    >
    <HeaderNavItem
      :layout="layout"
      icon="puzzle-piece"
      :label="text"
      @click="handleClick"
    />
  </form>
</template>

<style scoped lang="scss" src="@scss/components/Widgets/Menu/LinkStudentApp.scss" />
